/* หน้ารวมเมนูย่อยของกลุ่มงานที่เลือก */
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Empty, Typography } from "antd";
import { AppstoreOutlined } from "@ant-design/icons";

import { usePermission } from "../../store/context/permission-context";
import { Authenticate } from "../../service/Authenticate.service";
import { getPinned, togglePin } from "../../utils/pinnedMenu";
import { buildGroups } from "../../utils/navGroups";
import Tile from "./Tile";
import TileGrid from "./TileGrid";

export default function ModuleMenu() {
  const { key } = useParams();
  const { canView } = usePermission();
  const groups = useMemo(() => buildGroups(canView), [canView]);

  const userId = Authenticate().getUserId();
  const [pinned, setPinned] = useState(() => getPinned(userId));
  const pinnedSet = new Set(pinned.map((p) => p.to));

  const group = groups.find((g) => g.key === key);

  if (!group) {
    return (
      <Card
      bordered={false}
      style={{
        margin: 16,
        borderRadius: 16,
        boxShadow: "0 4px 18px rgba(15,23,42,.05)",
      }}
    >
        <Empty description="ไม่พบกลุ่มงานนี้ หรือไม่มีสิทธิ์เข้าถึง" />
      </Card>
    );
  }

  return (
    <Card
      bordered={false}
      style={{
        margin: 16,
        borderRadius: 16,
        boxShadow: "0 4px 18px rgba(15,23,42,.05)",
      }}
    >
      <Typography.Title level={5} style={{ marginTop: 0, marginBottom: 16, textAlign: "center" }}>
        {group.title}
      </Typography.Title>
      <TileGrid>
        {group.items.map((item) => (
            <Tile
              key={item.to}
              icon={item.icon || <AppstoreOutlined />}
              title={item.title}
              to={item.to}
              disabled={!item.allowed}
              pinned={pinnedSet.has(item.to)}
              onTogglePin={() =>
                setPinned(
                  togglePin(userId, { title: item.title, to: item.to })
                )
              }
            />
        ))}
      </TileGrid>
    </Card>
  );
}
